/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { CARDGROUPINFO } from '../model/cARDGROUPINFO';
import { CARDINFO } from '../model/cARDINFO';
import { POLLERCONFIGURATIONINFO } from '../model/pOLLERCONFIGURATIONINFO';
import { RESPONSEITEM } from '../model/rESPONSEITEM';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CardGroupsService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Get cards of a card group
     * @param cardGroupId Id of requested card group
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsCardGroupIdCardsGet(cardGroupId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CARDINFO>>;
    public cardGroupsCardGroupIdCardsGet(cardGroupId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CARDINFO>>>;
    public cardGroupsCardGroupIdCardsGet(cardGroupId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CARDINFO>>>;
    public cardGroupsCardGroupIdCardsGet(cardGroupId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (cardGroupId === null || cardGroupId === undefined) {
            throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdCardsGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<CARDINFO>>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}/cards`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Move cards to the selected group
     * @param cardGroupId ID of the target card group
     * @param eids The list containing EIDs of cards to be assigned to the target card group
     * @param sourceId ID of the source card group containing cards to be moved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsCardGroupIdCardsPut(cardGroupId: number, eids: Array<string>, sourceId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<RESPONSEITEM>>;
    public cardGroupsCardGroupIdCardsPut(cardGroupId: number, eids: Array<string>, sourceId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RESPONSEITEM>>>;
    public cardGroupsCardGroupIdCardsPut(cardGroupId: number, eids: Array<string>, sourceId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RESPONSEITEM>>>;
    public cardGroupsCardGroupIdCardsPut(cardGroupId: number, eids: Array<string>, sourceId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (cardGroupId === null || cardGroupId === undefined) {
            throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdCardsPut.');
        }
        if (eids === null || eids === undefined) {
            throw new Error('Required parameter eids was null or undefined when calling cardGroupsCardGroupIdCardsPut.');
        }
        if (sourceId === null || sourceId === undefined) {
            throw new Error('Required parameter sourceId was null or undefined when calling cardGroupsCardGroupIdCardsPut.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (sourceId !== undefined) {
            queryParameters = queryParameters.set('source_id', <any>sourceId);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<Array<RESPONSEITEM>>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}/cards`,
            eids,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Delete a card group from the database
     * @param cardGroupId Id of requested card group
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsCardGroupIdDelete(cardGroupId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardGroupsCardGroupIdDelete(cardGroupId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardGroupsCardGroupIdDelete(cardGroupId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardGroupsCardGroupIdDelete(cardGroupId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (cardGroupId === null || cardGroupId === undefined) {
            throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Get information about the card group
     * @param cardGroupId Id of requested card group
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsCardGroupIdGet(cardGroupId: string, observe?: 'body', reportProgress?: boolean): Observable<CARDGROUPINFO>;
    public cardGroupsCardGroupIdGet(cardGroupId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CARDGROUPINFO>>;
    public cardGroupsCardGroupIdGet(cardGroupId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CARDGROUPINFO>>;
    public cardGroupsCardGroupIdGet(cardGroupId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (cardGroupId === null || cardGroupId === undefined) {
            throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<CARDGROUPINFO>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Delete poller configuration for the card group.
     * @param cardGroupId Identifier of the card group, for which poller configuration will be deleted.
     * @param pollerType Type of poller for which configuration updates will be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsCardGroupIdPollerDelete(cardGroupId: string, pollerType: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardGroupsCardGroupIdPollerDelete(cardGroupId: string, pollerType: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardGroupsCardGroupIdPollerDelete(cardGroupId: string, pollerType: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardGroupsCardGroupIdPollerDelete(cardGroupId: string, pollerType: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (cardGroupId === null || cardGroupId === undefined) {
            throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdPollerDelete.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardGroupsCardGroupIdPollerDelete.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}/poller/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Returns configuration for specified poller for specified card group
     * @param cardGroupId Identifier of the card group, for which poller configuration will be returned.
     * @param pollerType Type of poller for which poller configuration will be returned
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsCardGroupIdPollerGet(cardGroupId: string, pollerType: string, observe?: 'body', reportProgress?: boolean): Observable<POLLERCONFIGURATIONINFO>;
    public cardGroupsCardGroupIdPollerGet(cardGroupId: string, pollerType: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<POLLERCONFIGURATIONINFO>>;
    public cardGroupsCardGroupIdPollerGet(cardGroupId: string, pollerType: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<POLLERCONFIGURATIONINFO>>;
    public cardGroupsCardGroupIdPollerGet(cardGroupId: string, pollerType: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (cardGroupId === null || cardGroupId === undefined) {
            throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdPollerGet.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardGroupsCardGroupIdPollerGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<POLLERCONFIGURATIONINFO>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}/poller/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Create new card group poller configuration.
     * @param cardGroupId Identifier of the card group, for which poller configuration will be created
     * @param pollerType Type of poller for which configuration will be created
     * @param cardGroupPollerConfiguration New card group poller configuration. All fields of update_entity are optional. If some field is not specified, this field will not be updated on card.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsCardGroupIdPollerPost(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardGroupsCardGroupIdPollerPost(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardGroupsCardGroupIdPollerPost(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardGroupsCardGroupIdPollerPost(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (cardGroupId === null || cardGroupId === undefined) {
            throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdPollerPost.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardGroupsCardGroupIdPollerPost.');
        }
        if (cardGroupPollerConfiguration === null || cardGroupPollerConfiguration === undefined) {
            throw new Error('Required parameter cardGroupPollerConfiguration was null or undefined when calling cardGroupsCardGroupIdPollerPost.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}/poller/`,
            cardGroupPollerConfiguration,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update poller configuration.
     * @param cardGroupId Identifier of the card group, for which poller configuration will be updated
     * @param pollerType Type of poller for which configuration will be updated
     * @param cardGroupPollerConfiguration New card group poller configuration. All fields of update_entity are optional. If some field is not specified, this field will not be updated on card.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsCardGroupIdPollerPut(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardGroupsCardGroupIdPollerPut(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardGroupsCardGroupIdPollerPut(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardGroupsCardGroupIdPollerPut(cardGroupId: string, pollerType: string, cardGroupPollerConfiguration: POLLERCONFIGURATIONINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (cardGroupId === null || cardGroupId === undefined) {
            throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdPollerPut.');
        }
        if (pollerType === null || pollerType === undefined) {
            throw new Error('Required parameter pollerType was null or undefined when calling cardGroupsCardGroupIdPollerPut.');
        }
        if (cardGroupPollerConfiguration === null || cardGroupPollerConfiguration === undefined) {
            throw new Error('Required parameter cardGroupPollerConfiguration was null or undefined when calling cardGroupsCardGroupIdPollerPut.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pollerType !== undefined) {
            queryParameters = queryParameters.set('poller_type', <any>pollerType);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}/poller/`,
            cardGroupPollerConfiguration,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update a card group
     * @param cardGroupId Id of card group to update
     * @param cardGroupObject New card group information
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsCardGroupIdPost(cardGroupId: string, cardGroupObject: CARDGROUPINFO, observe?: 'body', reportProgress?: boolean): Observable<CARDGROUPINFO>;
    public cardGroupsCardGroupIdPost(cardGroupId: string, cardGroupObject: CARDGROUPINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CARDGROUPINFO>>;
    public cardGroupsCardGroupIdPost(cardGroupId: string, cardGroupObject: CARDGROUPINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CARDGROUPINFO>>;
    public cardGroupsCardGroupIdPost(cardGroupId: string, cardGroupObject: CARDGROUPINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (cardGroupId === null || cardGroupId === undefined) {
            throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdPost.');
        }
        if (cardGroupObject === null || cardGroupObject === undefined) {
            throw new Error('Required parameter cardGroupObject was null or undefined when calling cardGroupsCardGroupIdPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<CARDGROUPINFO>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}`,
            cardGroupObject,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Card group list getting operation. This is the operation to get a list of card groups managed by the authenticated account
     * @param offset An offset for a list (required for pagination)
     * @param limit A maximum number of entries returned by the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsGet(offset?: number, limit?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<CARDGROUPINFO>>;
    public cardGroupsGet(offset?: number, limit?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CARDGROUPINFO>>>;
    public cardGroupsGet(offset?: number, limit?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CARDGROUPINFO>>>;
    public cardGroupsGet(offset?: number, limit?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (limit !== undefined) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<CARDGROUPINFO>>(`${this.basePath}/card_groups`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Number of card groups getting operation. This is the operation to get a number of card groups managed by the authenticated account
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsHead(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cardGroupsHead(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cardGroupsHead(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cardGroupsHead(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.head<any>(`${this.basePath}/card_groups`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Register new card group in the database. Account should be granted with special permissions for this procedure
     * @param cardGroupObject 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cardGroupsPut(cardGroupObject: CARDGROUPINFO, observe?: 'body', reportProgress?: boolean): Observable<CARDGROUPINFO>;
    public cardGroupsPut(cardGroupObject: CARDGROUPINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CARDGROUPINFO>>;
    public cardGroupsPut(cardGroupObject: CARDGROUPINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CARDGROUPINFO>>;
    public cardGroupsPut(cardGroupObject: CARDGROUPINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (cardGroupObject === null || cardGroupObject === undefined) {
            throw new Error('Required parameter cardGroupObject was null or undefined when calling cardGroupsPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<CARDGROUPINFO>(`${this.basePath}/card_groups`,
            cardGroupObject,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/api/cardGroups.service.ts